var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuttrema-layout-mobile-ready',{ref:"mobileLayout",class:[("is-" + _vm.gender)],attrs:{"theme":"participant"}},[_c('router-view'),_vm._v(" "),_c('template',{slot:"sidebar"},[_c('participant-main-menu',{attrs:{"PersonalProfile":_vm.PersonalProfile,"InstanceInfo":_vm.InstanceInfo},on:{"close":_vm.closeSidebar}})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298dc028","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/layout-set/participant/layout-set-participant.vue
// module id = 2981
// module chunks = 0